import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { LocalizationService } from '@services/localization.service';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { environment } from '@environments/environment';
import { DelayQueueExecutor } from 'rx-queue';
import { DimmerService } from '@services/dimmer.service';
import { CasinoRoutingDialog } from './casino-routing-dialog';
import { SureRoutingDialog } from './sure-routing-dialog.ts';
import { CasinoRegisterModal } from './casino-register-modal';
import { tr } from 'date-fns/locale';
import { SignOutDialog } from '@app/dialogs/sign-out.dialog';
import { isNaN, throttle } from 'lodash';
import { PromotionService } from '@services/promotion.service';
import { setCookie } from '@environments/environment';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { from, Subscription } from 'rxjs';

declare let $;
declare let zE: any;

type betStopReasonEventListType = betStopReasonEventType[];

type betStopReasonEventType = {
  BetradarMatchId?: string;
  betStopReasonId?: number;
  time?: number;
  teamScore?: {
    homeTeamScore: string;
    awayTeamScore: string;
  };
  homeTeamName?: string;
  awayTeamName?: string;
};

@Component({
  selector: 'navbar',
  templateUrl: '../sharedTemplates/navbar.component.html',
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() isCasino = false;
  private oldLiveMatch: any = [];
  private oldLiveMatchCreatedDate: any = '';
  private betStopReasonEventList: betStopReasonEventListType = [];
  private betStopReasonEventExecutor = new DelayQueueExecutor(8 * 1000);
  public betStopReasonEvent: betStopReasonEventType = {};
  private betStopReasonEventListener: EventEmitter<any> = new EventEmitter();
  subscription: Subscription;
  searchValue = new FormControl('');

  lastLoginDate: any;
  customerInfo: any;
  leftMenu: false;
  rightMenu: false;

  _BalanceAmount;

  isSignIn = false;

  searchState = false;
  searchFb: UntypedFormGroup;

  liveNavBarSubscription;
  liveMatchList = [];
  oldLiveMatchList = [];

  narvbarDateTimeInterval;
  narvbarDateTime = '';

  langDatas;
  langDatasArry = [];

  currentRoute = '';
  isSpinning = false;
  IsRegisterActive = true;
  accountTabMenu;
  constructor(
    public _Renderer2: Renderer2,
    public _ElementRef: ElementRef,
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _fbuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    public _DataHelper: DataHelper,
    private _Router: Router,
    private cp: DecimalPipe,
    public _MatDialog: MatDialog,
    public _LocalizationService: LocalizationService,
    private _webWorkerService: WebWorkerService,
    private route: ActivatedRoute,
    public _DimmerService: DimmerService,
    public _PromotionService: PromotionService
  ) {
    this.IsRegisterActive = environment.IsRegisterActive;
    //
    // this.currentRoute = this._UiHelper.currentRoute;
    // this._UiHelper.currentRouteListener.subscribe((x) => this.currentRoute = x);

    this.searchFb = _fbuilder.group({
      searchInput: new UntypedFormControl({ value: '', disabled: false }),
    });

    this.setBetStopReasonLiveData();

    this.betStopReasonEventListener.subscribe((x: betStopReasonEventType) => {
      this.betStopReasonEventExecutor
        .execute(() => x)
        .then((i: betStopReasonEventType) => {
          this.betStopReasonEvent = i;
        });
      this.betStopReasonEventExecutor
        .execute(() => x)
        .then((i: betStopReasonEventType) => {
          this.betStopReasonEvent = {};
        });
    });

    this._Router.events.subscribe(routeEvent => {
      if (routeEvent instanceof NavigationEnd) {
        if (this._Router.url.toString() == '/betslip' || this._Router.url.toString() == '/mybets') {
          this._UiHelper.setFooterState(false);
        } else {
          this._UiHelper.setFooterState(true);
        }

        this.currentRoute = this._Router.url.toString();

        if (this.liveNavBarSubscription != undefined) {
          try {
            this.liveNavBarSubscription.unsubscribe();
          } catch (e) {
            console.log(e);
          }
        }
        if (this._Router.url.toString() == '/live') {
          //unsubscribe from live
        } else {
          this.liveNavBarSubscription = this._DataHelper.liveDataListener.subscribe(y => {
            this.liveMatchList = y;

            this.dataRebuild();
          });
        }
      }
    });
    this._Router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.searchValue.setValue(''); // Route değiştiğinde searchValue sıfırlanır
    });

    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });
  }

  setBetStopReasonLiveData() {
    const createdEventId = (event: any): string => {
      if (event?.BetradarMatchId) {
        return `${event.BetradarMatchId}-${event.HomeScore}-${event.AwayScore}`;
      }

      return '';
    };
    this._DataHelper.liveDataListener.subscribe(x => {
      if (x && x.length > 0) {
        x.forEach((i: any) => {
          if (i.SportId === 1 && this.betStopReasonEventList.filter(z => z.BetradarMatchId === createdEventId(i)).length === 0) {
            // sport => futbol
            if (this.oldLiveMatchCreatedDate !== '' && new Date().getTime() - this.oldLiveMatchCreatedDate <= 60 * 1000) {
              const oldEventData = this.oldLiveMatch.filter(z => z.BetradarMatchId === i.BetradarMatchId);
              if (oldEventData.length > 0 && (oldEventData[0].HomeScore !== i.HomeScore || oldEventData[0].AwayScore !== i.AwayScore)) {
                // önceki event ile karşılaştırma, gol gerçekten oldu ise gösterim yapıyoruz
                this.betStopReasonEventList.push({
                  BetradarMatchId: createdEventId(i),
                  betStopReasonId: oldEventData[0].HomeScore !== i.HomeScore ? 4 : 5,
                  teamScore: {
                    homeTeamScore: i.HomeScore,
                    awayTeamScore: i.AwayScore,
                  },
                  homeTeamName: i.HomeTeam,
                  awayTeamName: i.AwayTeam,
                  time: new Date().getTime(),
                });
                this.betStopReasonEventListener.emit({
                  BetradarMatchId: createdEventId(i),
                  betStopReasonId: oldEventData[0].HomeScore !== i.HomeScore ? 4 : 5,
                  teamScore: {
                    homeTeamScore: i.HomeScore,
                    awayTeamScore: i.AwayScore,
                  },
                  homeTeamName: i.HomeTeam,
                  awayTeamName: i.AwayTeam,
                  time: new Date().getTime(),
                });
              }
            }
          } else {
            if (this.betStopReasonEventList.filter(x => x.BetradarMatchId === createdEventId(i)).length > 0) {
              this.betStopReasonEventList = this.betStopReasonEventList.filter(x => x.BetradarMatchId !== createdEventId(i));
            }
          }
        });
        this.oldLiveMatch = x;
        this.oldLiveMatchCreatedDate = new Date().getTime();
      }
    });
  }
  detectIsZero(value) {
    const normalizedValue = value.replace(',', '.');
    return parseFloat(normalizedValue) === 0;
  }

  getSearch(e) {
    this.searchFb.getRawValue().searchInput.length == 0 ? this.searchFb.setValue({ searchInput: e }) : null;
    //console.log("-getSearch-",e);
    this._ApiService.getSearch(e).then(x => {
      this._DataHelper.setSearchData(x);
      this._Router.navigate(['search', e]);
    });
  }

  ngOnInit() {
    this._UiHelper.dimmerListener.subscribe(({ status, modalId }: { status: string; modalId?: string }) => {
      if (status === 'open') {
        this._DimmerService.setActiveModalId(modalId);
      } else if (status === 'closed') {
        this._DimmerService.clearActiveModalId();
      }
    });
    this.subscription = this.searchValue.valueChanges
      .pipe(
        debounceTime(500), // Kullanıcının yazmayı bırakmasının ardından 500ms bekler
        distinctUntilChanged(), // Sadece farklı arama terimleri için çalışır
        switchMap(term => {
          return from(this.getSearchInput(term)); // Promiseyi observable'a dönüştürür
        })
      )
      .subscribe(
        results => {
          this._DataHelper.setSearchData(results);
        },
        error => console.log('err', error)
      );
  }
  getSearchInput(term: string) {
    this._UiHelper.searchTerm = term;

    if (term && term.length >= 3) {
      return this._ApiService
        .getSearchp1001(term)
        .then(x => {
          this._DataHelper.setSearchData(x);
          if (x && x.length === 0) {
            this._UiHelper.hasSearchData = false;
          } else {
            this._UiHelper.hasSearchData = true;
          }
        })
        .catch(err => console.log('err', err));
    } else if (term == '') {
      const searchKey = 'All';
      return this._ApiService
        .getSearchp1001(searchKey)
        .then(x => {
          this._DataHelper.setSearchData(x);
          if (x && x.length === 0) {
            this._UiHelper.hasSearchData = false;
          } else {
            this._UiHelper.hasSearchData = true;
          }
        })
        .catch(err => console.log('err', err));
    } else {
      //Observable hatası almamak için manuel boş array atandı, 3 harften küçükse

      this._DataHelper.setSearchData([]);

      this._UiHelper.hasSearchData = false;
      return [];
    }
  }

  walletSelectChange(walletItem) {
    if (walletItem?.IsActive) {
      this._UiHelper.dimmerListener.emit({
        status: 'closed',
      });
      this._UiHelper.setLoadingDialog(true);

      this._ApiService.switchWallet(walletItem.CustomerId, walletItem.BranchId).then(result => {
        this._DataHelper.selectedWallet = walletItem;
        if (environment.isMySlipLive) {
          this._DataHelper.mySlipMatchListApiCallListener.emit();
        }
        this._ApiService
          .getClient()
          .then(result => {
            this._UiHelper.setLoadingDialog(false);
            this._UserHelper.setUser(result);
          })
          .catch();

        this._ApiService.getTaxRate().then(result => {
          this._DataHelper.setTaxRate(result);
        });
      });
    }
  }

  ngAfterViewInit() {
    this.narvbarDateTimeInterval = setInterval(() => {
      const narvbarTime = new Date().toLocaleTimeString();
      const narvbarDate = new Date().toLocaleDateString();
      this.narvbarDateTime = narvbarDate + ' ' + narvbarTime;
    }, 1000);
    // this.getWalletList()

    // this.searchFb.valueChanges
    //   .pipe(filter((query) => query.searchInput.length > 2))
    //   .pipe(debounceTime(500))
    //   .pipe(distinctUntilChanged())
    //   .subscribe(val => {
    //     //console.log('Search ----', val);
    //     this.getSearch(val.searchInput);
    //
    //   });

    this._DataHelper.searchDataUrlListener.subscribe(x => {
      this.getSearch(x);
    });

    this._UserHelper.signInListener.subscribe(x => {
      if (x) {
        if (this._UserHelper.customerUser != undefined) {
          this._BalanceAmount = this._UserHelper.customerUser.BalanceAmount;
        }
        this.isSignIn = this._UserHelper.isSignedIn;
        this.lastLoginDate = Number(this._UserHelper.customerUser.LastLoginDate.toString().replace(/\D/g, ''));
        this.customerInfo = this._UserHelper.customerUser;
      } else {
        this.lastLoginDate = new Date();

        this.isSignIn = this._UserHelper.isSignedIn;
        this.customerInfo = this._UserHelper.customerUser;
      }
    });
    setInterval(() => {
      if (this._UserHelper.customerUser != undefined) {
        this.getUnreadMessage();
      }
    }, 300000);
  }

  getUnreadMessage() {
    if (this._UserHelper.isSignedIn == true) {
      this._ApiService.getUnreadMessage().then(result => {
        if (result != null && result != '') {
          this._UserHelper.setMessageCount(result[0].UnreadMessageCount);
        }
      });
    }
  }

  dataRebuild() {
    const isMySlipLive = environment.isMySlipLive;
    const wwsConfig = {
      isMySlipEnvironment: isMySlipLive,
      isMySlipButton: this._DataHelper.isMySlipButton,
      mySlipMatchList: this._DataHelper.mySlipMatchList,
      langCode: this._LocalizationService.LANGCODE,
      lml: this.liveMatchList,
      old_lml: this.oldLiveMatchList,
      mfbysk: '',
      lfi: [],
      cardList: [],
      oddtype: ['9', 9, 8],
      favorable: [],
      isLive: true,
      liveSortbyTime: false,
      liveFavoriteButtonStatus: false,
      liveFavoriteData: this._DataHelper.getLiveFavoriteTournamentData(),
    };

    if (this.liveMatchList === undefined) {
      return;
    }

    const promise = this._webWorkerService
      .run(this._DataHelper.webWorkerLiveJob, wwsConfig)
      .then(result => {
        try {
          this.oldLiveMatchList = this.liveMatchList;
        } catch (e) {
          console.warn(e);
        }
      })
      .catch();
  }

  changeTheme() {
    this._UiHelper.navbarDarkThemeState = true;
    this._UiHelper.darkThemeListener.emit();
  }

  ngOnDestroy() {
    if (this.narvbarDateTimeInterval) {
      clearInterval(this.narvbarDateTimeInterval);
    }
  }

  langDropdownOpen() {
    // this.langDropdownIsOpen = !this.langDropdownIsOpen;
    this._UiHelper.langDropdownOpen();
  }
  settingsDropDownOpen() {
    this._UiHelper.dimmerListener.emit({
      status: 'open',
      modalId: 'settingNavbarDimmer',
    });
  }
  userDropDownOpen() {
    this._UiHelper.dimmerListener.emit({
      status: 'open',
      modalId: 'userNavbarDimmer',
    });
  }

  userDropDownClosed() {
    this._UiHelper.dimmerListener.emit({
      status: 'closed',
    });
  }
  loginDropDownOpen() {
    this._Router.navigate(['home']);
  }
  async openCasinop1001() {
    if (this._UserHelper.isSignedIn) {
      const dialogRef = this._MatDialog;
      this._ApiService.getCasinoRegisterInfo().then(result => {
        if (result && !result.Success) {
          this._UiHelper.closeAllMenus();
          dialogRef.open(CasinoRegisterModal, {
            width: '550px',
            panelClass: 'casino-dialog',
            data: result,
          });
        } else {
          if (this._UiHelper.insicStatus === 2) {
            this._UiHelper.closeAllMenus();
            dialogRef.open(CasinoRoutingDialog, {
              width: '350px',
              panelClass: 'casino-dialog',
            });
          } else {
            dialogRef.open(SureRoutingDialog, {
              width: '350px',
              panelClass: 'casino-dialog',
            });
          }
        }
      });
    } else {
      this._UiHelper.dimmerListener.emit({
        status: 'open',
        modalId: 'loginDimmer',
      });
    }
  }

  openSideBar() {
    this._UiHelper.SetRightMenuState('open');
  }

  changeActiveLanguage(x) {
    this._LocalizationService.changeLang(x);
  }
  shopDropDownOpen() {
    this._UiHelper.dimmerListener.emit({
      status: 'open',
      modalId: 'walletDimmer',
    });
  }

  accountMenudsadasd() {
    this._UiHelper.dimmerListener.emit({
      status: 'closed',
    });
    this._Router.navigate(['/account/bet-slip']);
  }

  openLeftMenu() {
    this._UiHelper.p1001SetLeftMenuState('open');
  }

  goToSportSearch() {
    this._UiHelper.setSportInputStatus(true);

    this._Router.navigate(['search']);
  }

  SignOutDialogOpener(x) {
    const dialogRef = this._MatDialog;
    this._DimmerService.clearActiveModalId();
    this._UiHelper.closeAllMenus();
    dialogRef.open(SignOutDialog, {
      width: '350px',
    });
  }

  refreshBalance = throttle(() => {
    this.isSpinning = true;
    this._ApiService.getWalletList().then(result => {
      this._UserHelper.setWalletList(result);
    });
    setTimeout(() => (this.isSpinning = false), 1000);
  }, 5000);

  loadScriptChat() {
    const script = this._Renderer2.createElement('script');
    script.id = 'ze-snippet';
    script.src = environment.liveChatUrl;
    script.onload = () => {
      // Zendesk widget'ını saklamak için API çağrısı.
      if (zE && typeof zE === 'function') {
        zE('webWidget', 'hide');
      } else {
        // zE fonksiyonu mevcut değilse, bir hata mesajı göster veya başka bir işlem yap
        console.error('Zendesk Chat widget not loaded properly.');
      }
    };
    this._Renderer2.appendChild(this._ElementRef.nativeElement, script);
  }
  showChatScreen() {
    this.loadScriptChat();
    setTimeout(() => {
      if (zE && typeof zE === 'function') {
        zE('webWidget', 'show');
        zE('webWidget', 'open');
      }
    }, 100);
  }

  onInputChange(event: Event) {
    if (this.currentRoute !== '/search') {
      this._Router.navigate(['/search']);
    } else {
      const inputElement = event.target as HTMLInputElement;
      const searchTerm = inputElement.value;
      this.searchValue.setValue(searchTerm);
    }
  }

  protected readonly environment = environment;
  protected readonly parseInt = parseInt;
  protected readonly tr = tr;
  protected readonly isNaN = isNaN;
}
